const data = {
    cards: [
        {
            title: "Push The Limits!",
            img: "https://user-images.githubusercontent.com/37080003/163595495-f3ddd08d-ca04-4b7b-bc22-8136678d5b0c.png",
            video: "",
            slides: "https://docs.google.com/presentation/d/1bWQO30suadkZChFcSriYZXSbSukIZgDyEDJnUmOuq8c/edit?usp=sharing",
            code: "https://gist.github.com/Ahmedsaed/455763cfc55c5e298e55eac1bbf05b9d",
            display: false
        },
        {
            title: "Hackathon 101",
            img: "https://user-images.githubusercontent.com/37080003/163681595-5233e8d3-2123-4f69-a44a-40c43cca2e06.png",
            video: "",
            slides: "https://docs.google.com/presentation/d/1BpB-jRLrdGsuve6K3a54tWxBR9pjWU8NW7rFcGMdgmw/edit?usp=sharing",
            code: "",
            display: false
        },
        {
            title: "Intro To GitHub",
            img: "https://user-images.githubusercontent.com/37080003/172421840-bc67cd84-3591-4dee-88ca-7e8ab3663a15.png",
            video: "https://youtu.be/Tc7hIkmwnko",
            slides: "https://docs.google.com/presentation/d/1L5Ed1R_jg7-PChqRprBq5uEpgJNOrqOzBZnO-Z86WXg/edit?usp=sharing",
            code: "https://github.com/Ahmedsaed",
            display: true
        },
        {
            title: "Intro To Git",
            img: "https://user-images.githubusercontent.com/37080003/172422756-6ec7df37-c59e-4f32-bc7a-bded61119901.png",
            video: "https://youtu.be/crDCgkJB3kA",
            slides: "https://docs.google.com/presentation/d/1_WHitTYovETTw-f00Fk-SE95NiSfU4jSMT6pZOKKjds/edit?usp=sharing&resourcekey=0-UqSdUESOzXb-H1P4ibvOvQ",
            code: "",
            display: true
        },
    ]
}

export default data;
